import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import { CircuitBoard, Split, Database, Cloud, Network, Share2 } from 'lucide-react';
import PLCManagement from './PLCManagement';
import ChannelManagement from './ChannelManagement';
import TagManagement from './TagManagement';
import OPCManagement from './OPCManagement';
import SocketManagement from './SocketManagement';
import WebSocketManagement from './WebSocketManagement';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`datasources-tabpanel-${index}`}
      aria-labelledby={`datasources-tab-${index}`}
      {...other}
      style={{ height: '100%' }}
    >
      {value === index && (
        <Box sx={{ height: '100%', p: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function DataSourcesLayout() {
  const location = useLocation();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);
  const [editTagId, setEditTagId] = useState(null);

  // URL query params'ı oku
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    const tagId = params.get('editTagId');

    // Tab seçimi
    if (tab === 'tags') {
      setActiveTab(2); // Noktalar sekmesi
    }

    // EditTagId varsa kaydet
    if (tagId) {
      setEditTagId(tagId);
      // URL'den query param'ı temizle
      history.replace('/datasources');
    }
  }, [location.search, history]);

  const tabs = [
    { label: 'PLC\'ler', icon: CircuitBoard, component: PLCManagement },
    { label: 'Kanallar', icon: Split, component: ChannelManagement },
    { label: 'Noktalar', icon: Database, component: TagManagement },
    { label: 'OPC Sunucuları', icon: Cloud, component: OPCManagement },
    { label: 'Windows Soketleri', icon: Network, component: SocketManagement },
    { label: 'WebSocket\'ler', icon: Share2, component: WebSocketManagement }
  ];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // editTagId kullanıldıktan sonra temizle
  const clearEditTagId = () => {
    setEditTagId(null);
  };

  return (
    <Box sx={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f8f4ff'
    }}>
      <Paper sx={{
        borderRadius: 0,
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper'
      }}>
        <Box sx={{ px: 3, py: 2, display: 'flex', alignItems: 'center' }}>
          <CircuitBoard size={24} style={{ marginRight: '12px', color: '#edbc45' }} />
          <Typography variant="h5" component="h1" sx={{ fontWeight: 600, color: '#edbc45' }}>
            Veri Kaynakları Yönetimi
          </Typography>
        </Box>

        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            px: 3,
            '& .MuiTab-root': {
              minHeight: 48,
              textTransform: 'none',
              fontSize: '0.875rem',
              fontWeight: 500,
              color: '#666',
              '&.Mui-selected': {
                color: '#edbc45',
              }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#edbc45',
              height: 3
            }
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <tab.icon size={16} />
                  {tab.label}
                </Box>
              }
            />
          ))}
        </Tabs>
      </Paper>

      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        {tabs.map((tab, index) => (
          <TabPanel key={index} value={activeTab} index={index}>
            {index === 2 ? (
              <TagManagement editTagId={editTagId} onEditTagIdUsed={clearEditTagId} />
            ) : (
              <tab.component />
            )}
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
}